/** Заставка першого завантаження публічної форми — без позначок внутрішньої системи. */
export function PublicFormLoading() {
  return (
    <div role="status" aria-label="Завантаження форми" className="flex min-h-dvh items-center justify-center bg-canvas px-4">
      <span className="text-meta text-fg-3">Завантаження форми…</span>
    </div>
  );
}
